import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TelegramIcon from '@mui/icons-material/Telegram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Avatar, Button, Paper } from '@mui/material';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container/Container';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import AppText from '../components/atoms/AppText';

const Footer = () => {
    const navigation = useNavigate();
    const { t } = useTranslation();

    const currentYear = new Date().getFullYear();
    const startYear = 2021;
    let requestID: number;

    // this naviateTo capture path by name attribute and navigate to that path kindly check if button has name attribute

    const navigateTo = (event: { preventDefault: () => void; stopPropagation: () => void; currentTarget: { getAttribute: (arg0: string) => any } }) => {
        event.preventDefault();
        event.stopPropagation();
        const path = event.currentTarget.getAttribute('name');
        cancelAnimationFrame(requestID);
        requestID = requestAnimationFrame(() => navigation(path));
    };
    return (
        <Paper elevation={1} sx={{ bgcolor: 'background.default', display: 'flex', mt: 1 }}>
            <Container maxWidth="lg">
                <Box py={3} display="flex" flexWrap="wrap" flexDirection="row">
                    <Box
                        width={{ xs: '100%', sm: '100%', md: '50%', lg: '60%' }}
                        justifyContent={{ xs: 'center', sm: 'center', md: 'flex-end', lg: 'flex-end' }}
                        sx={{ textAlign: { xs: 'center', sm: 'center', md: 'left', lg: 'left' } }}
                    >
                        <Button
                            onClick={navigateTo}
                            name="/"
                            sx={{ color: 'text.primary', textTransform: 'uppercase', fontWeight: 600 }}
                            startIcon={<Avatar src={require('./../assests/images/icon_presign.png')} />}
                        >
                            UZOFFER
                        </Button>
                        <Button onClick={navigateTo} sx={{ paddingRight: 2, paddingLeft: 2 }} name="/term-and-condition">
                            <AppText textSize={12} style={{ color: 'text.primary', fontWeight: 550 }}>
                                {t('per_sign_up_page.term_condition')}
                            </AppText>
                        </Button>
                        <Button onClick={navigateTo} sx={{ paddingRight: 2, paddingLeft: 2 }} name="/privacy">
                            <AppText textSize={12} style={{ color: 'text.primary', fontWeight: 550 }}>
                                {t('privacy.title')}
                            </AppText>
                        </Button>
                        <Button sx={{ color: 'text.primary' }} onClick={navigateTo} name="/about_us">
                            <AppText textSize={12} style={{ color: 'text.primary', fontWeight: 550 }}>
                                {t('account_about.about_us')}
                            </AppText>
                        </Button>
                    </Box>

                    <Box
                        pt={{ xs: 2, sx: 2 }}
                        width={{ xs: '100%', sm: '100%', md: '50%', lg: '40%' }}
                        sx={{ display: 'flex', alignItems: 'end' }}
                        justifyContent={{ xs: 'center', sm: 'center', md: 'flex-end', lg: 'flex-end' }}
                    >
                        <Link href="https://apps.apple.com/app/id1597640845" target="_blank" sx={{ textAlign: 'right' }}>
                            <Box
                                component={'img'}
                                src={require('./../assests/images/icon_appstore.png')}
                                sx={{
                                    width: { xs: '45%', lg: 135 },
                                    height: { xs: '25%', lg: 40 },
                                    float: 'center',
                                    marginRight: 1
                                }}
                            />
                        </Link>

                        <Link href="https://play.google.com/store/apps/details?id=com.uzoffer.UzOffer" target="_blank" sx={{ textAlign: 'left' }}>
                            <Box
                                component={'img'}
                                src={require('./../assests/images/icon_googleplay.png')}
                                sx={{
                                    width: { xs: '45%', lg: 135 },
                                    height: { xs: '25%', lg: 40 },
                                    float: 'center'
                                }}
                            />
                        </Link>
                    </Box>
                </Box>
                <Divider light />
                <Box py={3} display="flex" flexWrap="wrap" flexDirection="row">
                    <Box width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }} sx={{ alignItems: 'center' }} justifyContent={{ xs: 'center', sm: 'center', md: 'flex-end', lg: 'flex-end' }}>
                        <AppText textSize={17} style={{ color: 'secondary.dark', fontWeight: '400' }}>
                            {'© UZOFFER ' + startYear + ' - ' + currentYear + ' ' + t('per_sign_up_page.all_rights_reserved')}
                        </AppText>
                    </Box>

                    <Box
                        width={{ xs: '100%', sm: '100%', md: '50%', lg: '50%' }}
                        sx={{ display: 'flex', alignItems: 'center' }}
                        justifyContent={{ xs: 'center', sm: 'center', md: 'flex-end', lg: 'flex-end' }}
                    >
                        <IconButton>
                            <Link href="https://www.youtube.com/playlist?list=PLbjxxJ9wPRGn3vxebHjQMEyjpixEEMCyY" target="_blank">
                                <Badge>
                                    <YouTubeIcon style={{ color: '#9A9FA5' }} />
                                </Badge>
                            </Link>
                        </IconButton>
                        <IconButton>
                            <Link href="https://uzoffer.com" target="_blank">
                                <Badge>
                                    <TwitterIcon style={{ color: '#9A9FA5' }} />
                                </Badge>
                            </Link>
                        </IconButton>
                        <IconButton>
                            <Link href="https://uzoffer.com" target="_blank">
                                <Badge>
                                    <InstagramIcon style={{ color: '#9A9FA5' }} />
                                </Badge>
                            </Link>
                        </IconButton>
                        <IconButton>
                            <Link href="https://uzoffer.com" target="_blank">
                                <Badge>
                                    <FacebookIcon style={{ color: '#9A9FA5' }} />
                                </Badge>
                            </Link>
                        </IconButton>
                        <IconButton>
                            <Link href="https://uzoffer.com" target="_blank">
                                <Badge>
                                    <TelegramIcon style={{ color: '#9A9FA5' }} />
                                </Badge>
                            </Link>
                        </IconButton>
                    </Box>
                </Box>
            </Container>
        </Paper>
    );
};

export default Footer;
